import React from 'react';
import DesktopDevPageSideVideoSidePrimis from './primis/DesktopDevPageSideVideoSide';
const DesktopDevPageSideVideoSide = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageSideVideoSidePrimis, {
        safety: safety
    });
};
DesktopDevPageSideVideoSide.displayName = 'DesktopDevPageSideVideoSide';
export default DesktopDevPageSideVideoSide;
